import { Field } from "@progress/kendo-react-form";

import {
  FormComboBox,
  FormInput,
  FormSwitch,
  FormTextArea,
} from "./form-components";

import { emailValidator, nameValidator, requiredValidator } from "./validators";
import { states } from "./data";
import { DeliveryProps } from "../interface/DeliveryProps";

export const DeliveryDetails = ({authToLeave, onToggleAuthToLeave, deliveryNotification, onToggleNotification}: DeliveryProps) => {

  return (
    <div>
      <h6>
        <strong>Deliver To Details</strong>
      </h6>
      <div className="row">
        <div className="col">
          <Field
            key={"shipfirstName"}
            id={"shipfirstName"}
            name={"shipfirstName"}
            label={"First Name"}
            component={FormInput}
            validator={nameValidator}
          />
        </div>
        <div className="col">
          <Field
            key={"shiplastName"}
            id={"shiplastName"}
            name={"shiplastName"}
            label={"Last Name"}
            component={FormInput}
            validator={nameValidator}
          />
        </div>
      </div>
      <Field
        key={"Address1"}
        id={"Address1"}
        name={"Address1"}
        label={"Address 1"}
        component={FormInput}
        validator={requiredValidator}
      />
      <Field
        key={"Address2"}
        id={"Address2"}
        name={"Address2"}
        label={"Address 2"}
        component={FormInput}        
      />
      <div className="row">
        <div className="col">
          <Field
            key={"city"}
            id={"city"}
            name={"city"}
            label={"City"}
            component={FormInput}
            validator={requiredValidator}
          />
        </div>
        <div className="col">
          <Field
            key={"shipstate"}
            id={"shipstate"}
            name={"shipstate"}
            label={"State"}
            component={FormComboBox}
            data={states}
            validator={requiredValidator}
          />
        </div>
        <div className="col">
          <Field
            key={"postcode"}
            id={"postcode"}
            name={"postcode"}
            label={"Post Code"}
            component={FormInput}
            validator={requiredValidator}
          />
        </div>
      </div>
      <Field
        key={"authtoleave"}
        id={"authtoleave"}
        name={"authtoleave"}
        label={"Authority to Leave"}
        component={FormSwitch}
        onChange={onToggleAuthToLeave}
        checked={authToLeave}
      />
      <Field
        key={"phone"}
        id={"phone"}
        name={"phone"}
        label={"Phone"}
        component={FormInput}        
      />
      <Field
        key={"trackingemail"}
        id={"trackingemail"}
        name={"trackingemail"}
        label={"Email"}
        component={FormInput}
        validator={emailValidator}
      />
      <Field
        key={"notification"}
        id={"notification"}
        name={"notification"}
        label={"Notify with tracking details"}
        component={FormSwitch}
        onChange={onToggleNotification}
        checked={deliveryNotification}
      />
      <Field
        key={"comments"}
        id={"comments"}
        name={"comments"}
        label={"Comments"}
        component={FormTextArea}        
      />
    </div>
  );
};
